export class LocationModel {
  country!: string;
  city!: string;

  constructor(input: any = {}) {
    this.country = input.country;
    this.city = input.city;
  }
}
